import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import Modal from '../../../components/Modal';
import trackEvent from '../eventTracking';
import { GradeContext } from "../index";

function BulkEditChildModal(props) {
  const {
    open,
    closeBulkEditChildModal,
    defaultBulkEditGrade,
    defaultBulkEditLockedGrade,
    defaultBulkEditHiddenGrade,
    editBulkChildCallback,
    yourX,
    lengthOfSelected
  } = props;

  // Yes, this should be importing the constant from GradeUtility. You fix it :-)
  const [grade, setGrade] = React.useState('kindergarten');
  const [lockedGrade, setLockedGrade] = React.useState(false);
  const [hiddenGrade, setHiddenGrade] = React.useState(false);

  React.useEffect(()=> {
    if (open) {
      setGrade(defaultBulkEditGrade);
      setLockedGrade(defaultBulkEditLockedGrade);
      setHiddenGrade(defaultBulkEditHiddenGrade);
    }
  }, [open]);

  function handleGradeChange(e) {
    setGrade(e.target.value);
  }

  function handleLockGradeToggle() {
    setLockedGrade(!lockedGrade);
  }

  function handleHideGradeToggle() {
    setHiddenGrade(!hiddenGrade);
  }

  function editBulkChild() {
    trackEvent('edit', 'completed', true);
    editBulkChildCallback({grade, lockedGrade, hiddenGrade});
  }

  const lockGradeClass = ['toggle-switch-small'];

  if (lockedGrade) {
    lockGradeClass.push('active');
  }

  const hideGradeClass = ['toggle-switch-small'];

  if (hiddenGrade) {
    hideGradeClass.push('active');
  }

  let titleText = "Edit settings for ";

  if (lengthOfSelected === 1) {
    titleText += `${1} ${yourX.singular}`;
  } else {
    titleText += `${lengthOfSelected} ${yourX.plural}`;
  }

  const { gradeMap } = useContext(GradeContext);

  const gradesOptions = [];

  if (gradeMap !== null) {
    gradeMap.availableGrades.forEach((avail) => {
      gradesOptions.push(
        <option key={gradeMap[avail].shortId} value={gradeMap[avail].shortId}>{gradeMap[avail].longDisplay}</option>);
    });
  }

  return (
    <Modal className="edit-child-modal bulk-edit" open={open} onClose={closeBulkEditChildModal}>
      <div className="title">{titleText}</div>
      <div className="modal-inner">
        {/* 1. Note to user */}
        <div className="bulk-edit-note-to-user">
          You can then change any individual setting as needed.
        </div>

        <form className="form flex-container flex-wrap">
          <div className="form-fields">

            {/* 2. Grade */}
            <div className="form-row input-row grade">
              <div className="floating not-empty">
                <span>Choose grade level</span>
                <select name="grade" data-cy="select-grade" value={grade || 'kindergarten'}
                        onChange={(e)=>{handleGradeChange(e)}}>
                  {gradesOptions}
                </select>
              </div>
            </div>

            {/* 3. Lock/Hide grade */}
            <div className="form form-childLock">
              <div className="toggle-form lock-grade" data-cy="lock-grade">
                <strong><i className="icon-info-circled"><div className="tooltip">When locked,
                  your child must stay within the chosen grade level in Guided Lessons.</div></i>Lock grade</strong>
                <div role='button' tabIndex={0} className={lockGradeClass.join(' ')}
                     onClick={handleLockGradeToggle} onKeyDown={handleLockGradeToggle}>
                  <div className="switch" />
                </div>
              </div>
              <div className="toggle-form hide-grade">
                <strong><i className="icon-info-circled"><div className="tooltip">When hidden,
                  your child will not see their grade in Guided Lessons.</div></i>Hide grade</strong>
                <div role='button' tabIndex={0} className={hideGradeClass.join(' ')}
                     onClick={handleHideGradeToggle} onKeyDown={handleHideGradeToggle}>
                  <div className="switch" />
                </div>
              </div>
            </div>
          </div>

          {/* 4. Buttons */}
          <div className="btn-container">
            <button type="button" className="btn btn-tertiary btn-cancel"
                    onClick={closeBulkEditChildModal}>Cancel</button>
            <button type="button" className="btn btn-primary btn-edit-child" onClick={editBulkChild}>Save</button>
          </div>
        </form>
      </div>
    </Modal>
  );
}

BulkEditChildModal.propTypes = {
  open: PropTypes.bool.isRequired,
  closeBulkEditChildModal: PropTypes.func.isRequired,
  defaultBulkEditGrade: PropTypes.string.isRequired,
  defaultBulkEditLockedGrade: PropTypes.bool.isRequired,
  defaultBulkEditHiddenGrade: PropTypes.bool.isRequired,
  yourX: PropTypes.shape({
    plural: PropTypes.string.isRequired,
    singular: PropTypes.string.isRequired
  }).isRequired,
  lengthOfSelected: PropTypes.number.isRequired,
  editBulkChildCallback: PropTypes.func.isRequired
};

export default BulkEditChildModal;
